<script setup lang="ts">
import type { Components } from '@ionic/core'
import EditMember from '~/pages/modals/editMember.modal.vue'
import type { AssociationMembershipResponse } from '~~/openapi-client/gen/schemas'

const nav = useTemplateRef<ComponentPublicInstance<Components.IonNav>>('nav')

const props = defineProps<{
	member: AssociationMembershipResponse
}>()

onMounted(async () => {
	const navEl = nav.value?.$el
	await navEl.setRoot(EditMember, { member: props.member, nav: navEl })
})
</script>

<template>
	<ion-nav ref="nav" />
</template>
